<ng-container *ngIf="layout==='frontend'">
  <app-navbar *ngIf="!isLoginPage"></app-navbar>
  <router-outlet (activate)="onActivate($event)"></router-outlet>
  <app-footer *ngIf="!isLoginPage" class="mt-auto"></app-footer>
</ng-container>
<app-backend *ngIf="layout==='backend'"></app-backend>
